<script lang="ts">
    import AppWraper from "../components/AppWraper.svelte";
    import { dateInputFormatter } from "../services/Functions";
    import type { RegisterExternalBackground } from "../Model/RegisterExternalBackground";
    import { recordsExternalBackgroundService } from "../services";
    import RegisterModalExternalAntecedents from "./RegisterModalExternalAntecedents.svelte";

    export let third_id: string;
    export let quantity: number
    let editRegister = null;
    let registers: any[];
    let newRegisters = false;

    $: loadRegisters();

    async function loadRegisters(): Promise<void> {

        registers = await recordsExternalBackgroundService.getRecordsByThird(third_id);

        quantity = registers.length
        
        registers.sort((a,b) => {
            return a.dateCreated < b.dateCreated ? -1 : 1;
        })
    }

    function registerUpdate(register: RegisterExternalBackground): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

</script>

<style>

</style>

        {#if registers}

            <div class="row mt-3">
                <div class="col-12">
                    {#if registers?.length}
                    <table class="table">
                        <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Procedencia</th>
                                    <th scope="col">Antecedentes</th>
                                    <th scope="col">Fecha</th>
                                </tr>
                        </thead>
                        <tbody>
                            {#each registers as register, index }
                                <tr>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        {#if register.originName}
                                            {register.originName}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.antecedentTypeName}
                                            {register.antecedentTypeName}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.dateCreated}
                                            {dateInputFormatter(register.dateCreated)}
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                    {:else}
                        <div class="text-center pt-5">
                            <hr>
                            <h4>No hay registros para mostrar</h4>
                        </div>
                    {/if}
                </div>
            </div>
        {/if}

    <RegisterModalExternalAntecedents register={editRegister}  bind:newRegister={newRegisters} on:registerUpdate={() => registerUpdate(editRegister)}/>
